var exports = {
  "Ki": "FeedVideo.module__video___STV2ek",
  "W_": "FeedVideo.module__poster___STV2ek",
  "lW": "FeedVideo.module__posterImage___STV2ek",
  "ZH": "FeedVideo.module__play___STV2ek",
  "uZ": "FeedVideo.module__playIcon___STV2ek",
  "p0": "FeedVideo.module__duration___STV2ek",
  "OC": "FeedVideo.module__player___STV2ek",
  "h5": "FeedVideo.module__status___STV2ek",
};

module.exports = exports;
